var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"test-cat-unclaim-btn",attrs:{"block":"","text":"","small":"","loading":_vm.loading},on:{"click":_vm.unclaim}},[_vm._v(" Unclaim ")])}
var staticRenderFns = []

export { render, staticRenderFns }